export const LEGAL_LINKS = [
  {
    url: '/legal/disclaimers',
    text: 'Disclaimers',
    id: 'disclaimers',
  },
  {
    url: '/legal/privacy-policy',
    text: 'Privacy Policy',
    id: 'pharmacy-policy',
  },
  {
    url: '/legal/terms-of-use',
    text: 'Terms of Use',
    id: 'terms-of-use',
  },
  {
    url: '/legal/hipaa-privacy-notice',
    text: 'HIPAA Privacy Notice',
    id: 'hipaa-privacy-notice',
  },
  {
    url: '/legal/accessibility',
    text: 'Accessibility',
    id: 'accessibility',
  },
];
